import './styles/globals.css';
import { installPolishZodErrors } from '@fos/shared/zod-pl';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from './app/providers';
import { AppRouter } from './app/router';

async function bootstrap() {
  installPolishZodErrors();

  // Tryb podglądu bez API (tylko `npm run dev`): ?mock=1 | ?mock=user | ?mock=demo, wyłączenie: ?mock=0.
  // W buildzie produkcyjnym `import.meta.env.DEV` = false, więc moduł atrap nie trafia do bundla.
  if (import.meta.env.DEV) {
    const { installMockIfRequested } = await import('./lib/mock');
    installMockIfRequested();
  }

  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    const { registerSW } = await import('virtual:pwa-register');
    registerSW({ immediate: true });
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('Brak elementu #root');
  createRoot(container).render(
    <StrictMode>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </StrictMode>,
  );
}

void bootstrap();
